import React, {Component} from 'react';
import moment from 'moment';

const dateFormatShow = 'DD MMM YYYY HH:mm';
let timer = null;

class CurrentDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'currentDate': this.getCurrentDate(),
    };
  }

  getCurrentDate() {
    return moment(new Date()).format(dateFormatShow);
  }

  componentDidMount() {
    this.startTimer();
  }
  
  startTimer() {
    timer = setInterval(() => {
      const currentDate = this.getCurrentDate();
      if (currentDate !== this.state.currentDate) {
        this.setState({currentDate});
      }
    }, 1000);
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  stopTimer() {
    if (timer) {
      clearInterval(timer);
    }
  }

  render() {
    return (
      <h3>{this.state.currentDate}</h3>
    );
  }
}

export default CurrentDate;
